import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SearchUsersComponent } from '@app/@shared/dialogs/search-users/search-users.component';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { AtribucionRegisterUserDto } from '@app/users/model/users-model';

const USER_TYPE: CommonDataDTO[] = [
  { id: '1', value: 'Grupo' },
  { id: '2', value: 'NIF/CIF' },
  { id: '3', value: 'Agente' },
  { id: '4', value: 'Vendedor' },
];

const USER_COMMERCIAL_TYPE: CommonDataDTO[] = [
  { id: '1', value: 'Centro Servicio' },
  { id: '2', value: 'DDGG' },
  { id: '3', value: 'Oficina BS' },
];

@Component({
  selector: 'scf-register-general',
  templateUrl: './register-general.component.html',
  styleUrls: ['./register-general.component.scss'],
})
export class RegisterGeneralComponent implements OnInit {
  @Input() title: string;
  @Input() isCommercial: boolean;
  @Input() isUser: boolean = false;

  isNameSelected: boolean = false;
  acceptButtonDisabled: boolean = true;
  createUserButtonDisabled: boolean = true;
  isSearchButtonDisabled: boolean;
  isUserSelected: boolean = false;
  selectedName: string;
  dynamicName: string;
  isSellerSelected: boolean = false;

  selectNameForm: FormGroup;
  userCharacteristicsForm: FormGroup;
  commercialPersonalDataForm: FormGroup;

  externalComercialList: CommonDataDTO[] = [];

  userDivisionList: CommonDataDTO[] = [
    { id: '10', value: 'CONSUMO' },
    { id: '20', value: 'AUTOS' },
  ];

  bankTypeList: CommonDataDTO[] = [
    { id: '1', value: 'Si' },
    { id: '2', value: 'No' },
  ];

  profileList: CommonDataDTO[] = [
    { id: '1', value: 'Adrministrador' },
    { id: '2', value: 'Admin. Gestión Marcas' },
  ];

  userTypeList: CommonDataDTO[] = [];

  atributionsList: AtribucionRegisterUserDto[] = [];

  constructor(private formBuilder: FormBuilder, private dialog: MatDialog) {}

  ngOnInit() {
    this.isSearchButtonDisabled = this.isUser;

    this.selectNameForm = this.formBuilder.group({
      name: ['', Validators.required],
    });

    this.selectNameForm.statusChanges.subscribe(() => {
      this.acceptButtonDisabled = this.selectNameForm.invalid;
    });

    this.userCharacteristicsForm = this.formBuilder.group({
      userType: ['1', Validators.required],
      user: [{ value: '', disabled: true }, Validators.required],
      profile: ['', Validators.required],
      password: ['', Validators.required],
      atributions: this.formBuilder.group({}),
    });

    if (!this.isUser) {
      this.userTypeList = USER_COMMERCIAL_TYPE;
      this.dynamicName = this.userTypeList[0].value;
      this.userCharacteristicsForm.addControl('bankType', new FormControl('', Validators.required));
      if (!this.isCommercial) {
        this.userCharacteristicsForm.controls.user.enable();
      }
    } else {
      this.userTypeList = USER_TYPE;
      this.dynamicName = this.userTypeList[0].value;
      this.userCharacteristicsForm.addControl('divisionType', new FormControl('', Validators.required));
      this.userCharacteristicsForm.addControl('externalComercial', new FormControl('', Validators.required));
      this.userCharacteristicsForm.addControl(
        'impersonatedUser',
        new FormControl({ value: '', disabled: true }, Validators.required)
      );
      this.userCharacteristicsForm.addControl(
        'brand',
        new FormControl({ value: '', disabled: true }, Validators.required)
      );

      this.userCharacteristicsForm.controls.externalComercial.valueChanges.subscribe(
        (value) => (this.isSearchButtonDisabled = value === null || value === undefined)
      );
    }

    this.userCharacteristicsForm.statusChanges.subscribe(() => {
      if (this.userCharacteristicsForm.valid && this.userCharacteristicsForm.controls.user.value) {
        this.createUserButtonDisabled = false;
      } else {
        this.createUserButtonDisabled = true;
      }
    });
  }

  searchForName() {
    //TODO: LLAMAR AL SERVICIO PARA COMPROBAR SI EL NOMBRE ESTA YA COGIDO
    this.selectedName = this.selectNameForm.controls.name.value;
    this.isNameSelected = this.selectNameForm.valid;
  }

  registerUser() {
    //TODO: LLAMAR AL SERVICIO DE REGISTRAR USUARIO

    const result = Object.assign({}, this.userCharacteristicsForm.value, {
      atributions: this.atributionsList.filter((x, i) => {
        if (x.activada === 'X') {
          return true;
        } else {
          return !!this.userCharacteristicsForm.value.atributions[i];
        }
      }),
    });
    //TODO: FALTARIA RECOGER TODOS LOS DATOS DE LOS CAMPOS DESHABILITADOS
    console.log(result);
  }

  comboPerfilSelection() {
    //TODO: HACER LA LLAMADA PARA, CON LA SELECCION DEL COMBO, RECUPERAR LAS ATRIBUCIONES DEL TIPO DE USUARIO
    this.atributionsList = [
      { atributionNumber: '000', atributionName: 'login', activada: 'X', index: 0 },
      { atributionNumber: '009', atributionName: 'Usuario de Impresión', activada: 'X', index: 1 },
      { atributionNumber: '316', atributionName: 'Cambiar Password Propia', activada: 'P', index: 2 },
      { atributionNumber: '708', atributionName: 'Reenviar correo consentimiento y firma', activada: 'X', index: 3 },
      { atributionNumber: '709', atributionName: 'Mantenimiento Lista blanca', activada: 'X', index: 4 },
      { atributionNumber: '710', atributionName: 'Mantenimiento Dispositivos Móviles', activada: 'P', index: 5 },
    ];

    const formArray = <FormGroup>this.userCharacteristicsForm.get('atributions');

    if (formArray !== null) {
      Object.keys(formArray.controls).forEach((key) => {
        formArray.removeControl(key);
      });
    }

    this.atributionsList.forEach((x) => {
      if (x.activada === 'X') {
        formArray.addControl(x.index.toString(), new FormControl({ value: true, disabled: true }));
      } else {
        formArray.addControl(x.index.toString(), new FormControl(false));
      }
    });

    // console.log(this.userCharacteristicsForm);
  }

  hasLoadedAtributions() {
    return this.atributionsList.length > 0 ? true : false;
  }

  checkboxRows(): number {
    if (this.atributionsList) {
      return this.atributionsList.length * 1.25 + 2; //va a haber 3 chechboxes por linea
    } else {
      return 0;
    }
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '700px';
    dialogConfig.data = 'tipo usuario'; //TODO: ESTO CAMBIA POR LO QUE SE MANDE AL DIALOG
    dialogConfig.disableClose = true;

    const modalDialog = this.dialog.open(SearchUsersComponent, dialogConfig);

    modalDialog.afterClosed().subscribe(
      (result: string) => {
        if (result) {
          if (this.isUser) {
            this.userCharacteristicsForm.controls.brand.enable();
            this.userCharacteristicsForm.controls.profile.enable();
            this.userCharacteristicsForm.controls.impersonatedUser.setValue(result);
          }
          //poner el usuario seleccionado en el campo nombre y desactivar este campo,
          this.userCharacteristicsForm.controls.user.setValue(result);
          //rellenar con sus datos todo lo que se despliega en la parte de abajo
          //TODO: LLAMAR AL SERVICIO PARA RECUPERAR LOS DATOS
          //TODO: AUN NO SE SABE SI SE LLAMARA DESDE EL POPUP O DESDE ESTE COMPONENTE

          //se habilita el formulario que es solo de visualizacion. habra que rellenarlo con los datos del usuario seleccionado
          if (this.userCharacteristicsForm.controls.division) {
            this.userCharacteristicsForm.controls.division.setValue('20');
          } else {
            this.userCharacteristicsForm.addControl('division', new FormControl({ value: '20', disabled: true }));
          }
          if (this.userCharacteristicsForm.controls.registerDate) {
            this.userCharacteristicsForm.controls.registerDate.setValue('20/12/2008');
          } else {
            this.userCharacteristicsForm.addControl(
              'registerDate',
              new FormControl({ value: '20/12/2008', disabled: true })
            );
          }
          if (this.userCharacteristicsForm.controls.description) {
            this.userCharacteristicsForm.controls.description.setValue(result);
          } else {
            this.userCharacteristicsForm.addControl('description', new FormControl({ value: result, disabled: true }));
          }
          if (this.userCharacteristicsForm.controls.nifcif) {
            this.userCharacteristicsForm.controls.nifcif.setValue('20123213A');
          } else {
            this.userCharacteristicsForm.addControl('nifcif', new FormControl({ value: '20123213A', disabled: true }));
          }
          if (this.userCharacteristicsForm.controls.phone) {
            this.userCharacteristicsForm.controls.phone.setValue('912020202');
          } else {
            this.userCharacteristicsForm.addControl('phone', new FormControl({ value: '912020202', disabled: true }));
          }
          if (this.userCharacteristicsForm.controls.email) {
            this.userCharacteristicsForm.controls.email.setValue('');
          } else {
            this.userCharacteristicsForm.addControl('email', new FormControl({ value: '', disabled: true }));
          }
          if (this.userCharacteristicsForm.controls.address) {
            this.userCharacteristicsForm.controls.address.setValue('PZ CATALUNYA 1 6 A');
          } else {
            this.userCharacteristicsForm.addControl(
              'address',
              new FormControl({ value: 'PZ CATALUNYA 1 6 A', disabled: true })
            );
          }
          if (this.userCharacteristicsForm.controls.town) {
            this.userCharacteristicsForm.controls.town.setValue('SABADELL');
          } else {
            this.userCharacteristicsForm.addControl('town', new FormControl({ value: 'SABADELL', disabled: true }));
          }
          if (this.userCharacteristicsForm.controls.province) {
            this.userCharacteristicsForm.controls.province.setValue('');
          } else {
            this.userCharacteristicsForm.addControl('province', new FormControl({ value: '', disabled: true }));
          }
          if (this.userCharacteristicsForm.controls.postalCode) {
            this.userCharacteristicsForm.controls.postalCode.setValue('08201');
          } else {
            this.userCharacteristicsForm.addControl('postalCode', new FormControl({ value: '08201', disabled: true }));
          }
          this.isUserSelected = true;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  loadExternalCommercials() {
    //TODO: LLAMAR AL SERVICIO PARA CARGAR LOS COMERCIALES EXTERNOS DEPENDIENDO DEL PRODUCTO (10 o 20)
    this.externalComercialList = [
      { id: '1', value: 'CAGUHUJ YOZONNUQE , YUNAO' },
      { id: '2', value: 'CORTES GARCIA , SEBASTIAN' },
      { id: '3', value: 'GAGZQUQE ONOQYEH , UNTAQO' },
    ];
  }

  resetCombos() {
    if (this.isUser) {
      let userTypeSelected = this.userCharacteristicsForm.controls.userType.value;
      this.dynamicName = this.userTypeList[userTypeSelected - 1].value;
      this.userCharacteristicsForm.reset();
      this.isUserSelected = false;
      this.atributionsList = [];
      this.userCharacteristicsForm.controls.userType.setValue(userTypeSelected);
      this.isSellerSelected =
        this.dynamicName === this.userTypeList.find((usertype) => usertype.value === 'Vendedor').value;
      if (this.isSellerSelected) {
        this.userCharacteristicsForm.addControl('seller', new FormControl('', Validators.required));
      } else {
        let seller = this.userCharacteristicsForm.controls['seller'];
        if (seller !== null) {
          this.userCharacteristicsForm.removeControl('seller');
        }
      }
    }
  }
}
